type DiscountLike = { code?: string; product?: string } | null;

export const isCompleteDiscount = (discount?: DiscountLike): boolean => !!discount?.code && !!discount?.product;

// The submission schema accepts a missing discount, but rejects one without a code or product on save.
export const withoutIncompleteDiscount = <T extends { discount?: DiscountLike }>(submission: T): T => {
  if (!submission || !('discount' in submission) || isCompleteDiscount(submission.discount)) {
    return submission;
  }

  const { discount, ...submissionWithoutDiscount } = submission;

  return submissionWithoutDiscount as T;
};
